import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EnumUnlockedFeature } from '@app/shared/models/user.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TooltipBubbleComponent } from '@app/shared/components/tooltip-bubble/tooltip-bubble.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { UserRepository } from '@app/shared/state/user/user.repository';

@Component({
  selector: 'slotcom-unlock-feature-modal',
  templateUrl: './unlock-feature.component.html',
  styleUrls: ['./unlock-feature.component.scss'],
  standalone: true,
  imports: [TooltipBubbleComponent, ButtonComponent, SharedModule, NavigationButtonComponent],
})
export class UnlockFeatureModalComponent {
  unlockFeatureModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private dialog = inject(MatDialog);
  private userRepo = inject(UserRepository);

  EnumUnlockedFeature = EnumUnlockedFeature;

  closeModal() {
    const feature = this.unlockFeatureModalData.data.featureId as EnumUnlockedFeature;

    this.eventManager.closeModal(
      new Modal(this.unlockFeatureModalData.id, ModalType.View, this.unlockFeatureModalData)
    );

    this.dialog
      .getDialogById(this.unlockFeatureModalData.id)
      .afterClosed()
      .subscribe(() => {
        this.userRepo.updateUser({
          unlockedFeatures: [...this.userRepo.user().unlockedFeatures, feature],
        });

        this.userRepo.pendingUnlockFeature.set(null);
      });
  }

  openFeature() {
    this.closeModal();

    this.dialog
      .getDialogById(this.unlockFeatureModalData.id)
      .afterClosed()
      .subscribe(() => {
        this.handleModal();
      });
  }

  private handleModal() {
    const feature = this.unlockFeatureModalData.data.featureId as EnumUnlockedFeature;
    let modal: NonPersistedModalName;

    switch (feature) {
      case EnumUnlockedFeature.Challenges:
        modal = NonPersistedModalName.DailyChallengeModalComponent;
        break;
      case EnumUnlockedFeature.Ranking:
        modal = NonPersistedModalName.RankingModal;
        break;
      case EnumUnlockedFeature.LimitedTimeEvents:
        modal = NonPersistedModalName.MultieventsModalComponent;
        break;
      default:
        break;
    }

    if (!modal) {
      this.closeModal();
      return;
    }

    this.eventManager.openModal(new Modal(modal, ModalType.View, { featureId: feature }));
  }
}
